import React from 'react';

export default function Loading({ additionalData }: {
  additionalData: {
    hitClassesLoading?: string;
    itemCount?: number;
  };
}) {
  const { hitClassesLoading, itemCount } = additionalData;
  return (
    <>
      {Array.from({ length: itemCount ?? 8 }, (_, index) => (
        <div key={index} className={`${hitClassesLoading ?? 'w-full'} py-8 border-b border-grey-100 first:pt-0 last:pb-0 last:border-0`}>
          <div
            className="group/card w-full relative no-underline transition-all overflow-hidden flex justify-start items-center gap-4 md:gap-8 bg-light animate-pulse"
          >
            <div className="bg-blue-100 aspect-square rounded-lg size-20 md:size-39 overflow-hidden shrink-0" />
            <div className="flex flex-1 flex-col gap-3 justify-center">
              <div className="bg-grey-500/50 w-23.5 md:w-27 h-3" />
              <div className="bg-dark/50 w-full max-w-50 h-5.75 md:h-7" />
              <div className="bg-grey-500/50 w-full h-16" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
